import { LineChevronRightSmall } from '@qr-front/icons/line-chevron-right-small'
import {
	socialLinkListAtom,
	TSocialLinkField,
} from 'features/generator/contentFormSections'
import { SOCIAL_PLATFORM_LIST } from 'features/generator/utils/socialPlatformsConfig'
import { useAtomValue } from 'jotai'
import { addMissingUrlProtocol } from 'utils/urlUtils'

export const SocialLinkItem = ({
	item: { platformId, name, url },
}: {
	item: TSocialLinkField
}) => {
	const Icon = SOCIAL_PLATFORM_LIST.find(({ id }) => id === platformId)?.[
		'Icon'
	]

	return (
		<li>
			<a
				href={addMissingUrlProtocol(url || '')}
				target="_blank"
				className="flex items-center justify-between gap-2 rounded-6 bg-light-grey-70 p-2"
				rel="noreferrer"
			>
				<div className="type-body-caption flex items-center gap-2">
					{Icon ? <Icon /> : null}
					<p>{name}</p>
				</div>
				<LineChevronRightSmall className="size-4" />
			</a>
		</li>
	)
}

export const SocialSection = () => {
	const socialLinkList = useAtomValue(socialLinkListAtom)

	return (
		<ul className="-m-2 flex flex-col gap-2">
			{socialLinkList.map((item) => (
				<SocialLinkItem key={item.platformId} item={item} />
			))}
		</ul>
	)
}
